<template>
  <el-tabs class="sample-survey-left" type="card" v-model="activeTab">
    <el-tab-pane label="题型" name="type">
      <el-scrollbar ref="scrollBar" :style="{ height: scrollHeight }" wrap-class="overflow-x-hidden">
        <survey-question-type :types="surveyQuestionTypes" :disabled-types="disabledTypes" class="px-4" @click="onClick" />
      </el-scrollbar>
    </el-tab-pane>
    <el-tab-pane label="大纲" name="outline">
      <outline-aside v-if="activeTab === 'outline'" />
    </el-tab-pane>
  </el-tabs>
</template>

<script>
import SurveyQuestionType from '@/components/survey/SurveyQuestionType'
import { surveyQuestionTypes } from '@/views/other-pages/sample-company/config'
import OutlineAside from '@/views/survey/edit/aside/OutlineAside'
import { ADD_QUESTION } from '@/assets/js/config/bus'
import SampleCompanyMixin from '@/views/other-pages/sample-company/sample-company-mixin'
import { questionType } from '@dygc/question'

export default {
  name: 'SampleSurveyLeft',
  components: { OutlineAside, SurveyQuestionType },
  mixins: [SampleCompanyMixin],
  data() {
    return {
      activeTab: 'type',
      scrollHeight: 0,
      surveyQuestionTypes: Object.freeze(surveyQuestionTypes)
    }
  },
  computed: {
    disabledTypes() {
      if (this.isPhone) return [questionType.CELLPHONE,questionType.NAME]
      else if (this.isEmail) return [questionType.EMAIL]
      else if (this.isAddress) return [questionType.POINT_POSITION]
      return []
    }
  },
  methods: {
    onClick(item) {
      this.$surveyBus.$emit(ADD_QUESTION, item.value)
    },
    resetHeight() {
      const { top } = this.$refs.scrollBar.$el.getBoundingClientRect()
      this.scrollHeight = window.innerHeight - top + 'px'
    },
    resizeHandler() {
      if (this.resizeTimer) {
        clearTimeout(this.resizeTimer)
      }
      this.resizeTimer = setTimeout(() => {
        this.resetHeight()
      }, 100)
    }
  },
  mounted() {
    setTimeout(() => {
      this.resetHeight()
    }, 100)
    window.addEventListener('resize', this.resizeHandler)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.resizeHandler)
  }
}
</script>

<style scoped lang="scss">
.sample-survey-left {
  height: 100%;
  background-color: #fff;
  box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.16);
  @apply bg-white border-r border-solid border-theme-text-gray border-opacity-10;
}
</style>
